import React from 'react';

import { Box, Container, Heading } from '@brand/components';

import { Post } from '@domain/entities';

import { Posts } from '@hoa/organisms';

import { useTrade, useTranslation } from '@hoa/hooks';

interface Props {
  posts: Post[] | [];
}

export const CategoryBlog = (props: Props) => {
  const { t } = useTranslation();
  const { tradeCategory } = useTrade();

  const title = t(`category:blog.title`, {
    trade: tradeCategory?.toLowerCase(),
  });

  return (
    <Box as="section" py={10} bg="gray.50">
      <Container>
        <Heading as="h2" variant="h3" mb={10} textAlign="center">
          {title}
        </Heading>
        <Posts posts={props.posts} />
      </Container>
    </Box>
  );
};
